const NODE_ENV = process.env.NODE_ENV || 'development'

// const scope = 'bt-subsidiaries', // BT Subsidiaries
const scope = '' // Localhost
const localhostUrl = 'https://reports.yourvoice.team'
const makeusbetterUrl = 'https://reports.yourvoice.team/api'

// for domain and clientId we need to update also src/index.html
const authDomain = 'wls-powerbireports.eu.auth0.com'
const authClientId = 'A9BcmEXtZL8HO8zbWBy8IWuwyldobHQ2'

// signalR
const signalRHubUrl = `${localhostUrl}/signalr`

// auth0
const authRedirect = `${localhostUrl}/close-popup`
const authLogoutUrl = `${localhostUrl}/`
const authAudience = 'https://reports.yourvoice.team/api/'

// base url
const apiBaseUrl = `${makeusbetterUrl}`
const publicPath = '/'
module.exports = {
  scope,
  authDomain,
  authClientId,
  authRedirect,
  authLogoutUrl,
  authAudience,
  signalRHubUrl,
  apiBaseUrl,
  /** The environment to use when building the project */
  env: NODE_ENV,
  /** The full path to the project's root directory */
  basePath: __dirname,
  /** The name of the directory containing the application source code */
  srcDir: 'src',
  /** The file name of the application's entry point */
  main: 'main',
  /** The name of the directory in which to emit compiled assets */
  outDir: 'dist',
  /** The base path for all projects assets (relative to the website root) */
  publicPath,
  /** Whether to generate sourcemaps */
  sourcemaps: true,
  /** A hash map of keys that the compiler should treat as external to the project */
  externals: {},
  /** A hash map of variables and their values to expose globally */
  globals: {},
  /** Whether to enable verbose logging */
  verbose: false,
  /** The list of modules to bundle separately from the core application code */
  vendors: [
    'react',
    'react-dom',
    'redux',
    'react-redux',
    'redux-thunk',
    'react-router',
  ],
}



// WEBPACK FOOTER //
// ./project.config.js